import React from 'react'
import styled from 'styled-components'
import theme from './theme.js'
import {BodyText} from './text.js'
import Link from './link.js'

const FooterInfoBar = () => {
  const privacy = `https://www.notion.so/aofolts/Barefootwear-Login-Privacy-Policy-172b7b386f9e80699752ef177a318746?pvs=4`
  const terms = `https://www.notion.so/aofolts/Barefootwear-Login-Terms-of-Service-172b7b386f9e8083b35ed729159280e4?pvs=4`

  return (
    <Container>
      <Item><Link url={privacy}>Privacy Policy</Link></Item>
      <Item><Link url={terms}>TOC</Link></Item>
    </Container>
  )
}

const Container = styled.div`
  padding: 1em;
  background: rgba(0,0,0,.1);
  display: flex;
  justify-content: center;
`

const Item = styled(BodyText)`
  margin-right: 1em;
  font-size: ${theme.font.size.p2};
`

export default FooterInfoBar